export interface Trend_data2 {
    imgurl : string;
}

let trend2:Trend_data2[] = [
    {
        imgurl : './img/trend/img4.jpg'
    },
    {
        imgurl : './img/trend/img5.jpg'
    },
    {
        imgurl : './img/trend/img6.jpg'
    },
    {
        imgurl : './img/trend/img7.jpg'
    }
]

export default trend2;